import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=3f5638b8"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports